<template>
  <div class="admin_home">
    <PayrollHeader />
    <div class="decision">
      <p>
        Welcome
        <span>{{username}}</span>; how do you want to continue?
      </p>
      <div>
        <div>
          <div class="decision__image">
            <img src="./../../../assets/images/money-bag.svg" alt="quick payroll" />
          </div>
          <p>Run Quick Payroll</p>
          <div class="decision__btn">
            <router-link to="/upload-csv">
              <div>Continue</div>
            </router-link>
          </div>
          <div class="decision__cover"></div>
        </div>
        <div>
          <div class="decision__image">
            <img src="./../../../assets/style/images/user.svg" alt="onboarding" />
          </div>
          <p>Continue with Onboarding</p>
          <div class="decision__btn">
            <router-link to="/setup-payroll">
              <div>Continue</div>
            </router-link>
          </div>
          <div class="decision__cover"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PayrollHeader from "../../partials/payrollHeader";

export default {
  name: "Decision",
  components: {
    PayrollHeader
  },
  data() {
    return {
      username: ""
    };
  },
  created() {
    if (this.$store.getters.currentAuthUser) {
      const user = this.$store.getters.currentAuthUser;
      this.username = user.firstname;
      return;
    }
    this.$router.push("/");
  }
};
</script>
<style lang="scss" scoped>
.decision {
  background-color: #fbfafa;
  padding-top: 50px;
  padding-bottom: 100px;
  padding-left: 10px;
  padding-right: 10px;
  min-height: 700px;

  > p {
    font-size: 25px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: normal;
    text-align: center;
    color: #000000;

    > span {
      color: #f79320;
    }

    @media (max-width: 1000px) {
      font-size: 20px;
    }
  }

  > div {
    max-width: 600px;
    margin: 50px auto 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: space-between;
    align-content: center;

    @media (max-width: 500px) {
      flex-direction: column;
      align-items: center;
    }

    > div {
      width: 45%;
      min-width: 200px;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      padding: 30px 0;
      margin: 10px 0;
      position: relative;

      > .decision__image {
        width: 40px;
        height: 40px;
        margin: auto;

        > img {
          width: 40px;
          height: 40px;
        }
      }

      > p {
        font-size: 16px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 0.96;
        letter-spacing: normal;
        text-align: left;
        color: #777777;
        text-align: center;
        margin: 30px 0;

        @media (max-width: 1000px) {
          font-size: 16px;
        }
      }

      > .decision__btn {
        width: 100px;
        margin: auto;
        border-radius: 5px;
        background-color: #5099de;
        cursor: pointer;
        overflow: hidden;

        > a {
          color: #ffffff;
          text-decoration: none;

          > div {
            padding: 12px 0;
            font-size: 12px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.22;
            letter-spacing: normal;
            text-align: center;
          }
        }
      }

      > .decision__cover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.4);
      }

      &:hover {
        > .decision__cover {
          display: none;
        }
      }
    }
  }
}
</style>
